import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { FrameworkContract, FrameworkContractsService } from '../../../core/api';
import { Store } from '@ngrx/store';
import { addFrameworkContract, addTupCustomer } from '../../../core/states/offer/offer.actions';
import { catchError, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FrameworkContractState } from '../../../core/states/offer/offer.state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const mapToFrameworkContractState = (frameworkContract: FrameworkContract): FrameworkContractState => {
  return {
    number: frameworkContract.number,
    name: frameworkContract.name,
    syriusKey: {
      contractNumber: frameworkContract.syrius_key.contract_number,
      personGroupShortDescription: frameworkContract.syrius_key.person_group_short_description,
    },
  };
};

const SWISSCOMM_FRAMEWORKCONTRACT_NUMBER = '1.041080.000.6';

export const tupGuard: CanActivateFn = (): UrlTree | Observable<UrlTree | boolean> => {
  const router: Router = inject(Router);
  const frameworkContractsService: FrameworkContractsService = inject(FrameworkContractsService);
  const store: Store = inject(Store);

  const saveTupFrameworkContractToStore = (frameworkContract: FrameworkContract): void => {
    store.dispatch(addFrameworkContract(mapToFrameworkContractState(frameworkContract)));
  };
  const contractFound$ = frameworkContractsService.findFrameworkContract(SWISSCOMM_FRAMEWORKCONTRACT_NUMBER).pipe(
    takeUntilDestroyed(),
    tap(saveTupFrameworkContractToStore),
    map(() => true),
    catchError(() => of(router.parseUrl('/framework-contracts-error'))),
  );

  contractFound$.pipe(takeUntilDestroyed()).subscribe((contractFound) => {
    if (contractFound) {
      store.dispatch(addTupCustomer());
    }
  });
  return contractFound$;
};
